<footer class="footer" id="footer">
  <div class="made group">
    <img width="240" height="41" loading="eager" src="images/caseactive-full-logo.png" alt="CaseActive">
    <div class="made-desktop">
      <ng-container *ngTemplateOutlet="made"></ng-container>
    </div>
  </div>
  <div class="about">
    <div class="about-us group">
      <h3 class="group-name">{{ 'About Case Active' | translate }}</h3>
      <a routerLinkActive="active" [routerLink]="language === 'en' ? ['/'] : [language, '/']" class="group-item link">{{ 'Home' | translate }}</a>
      <a routerLinkActive="active" [routerLink]="language === 'en' ? ['overview'] : [language, 'overview']" class="group-item link">{{ 'Overview' | translate }}</a>
      <span class="group-item">{{ 'Compare' | translate }}</span>
      <a routerLinkActive="active" [routerLink]="language === 'en' ? ['pricing'] : [language, 'pricing']" class="group-item link">{{ 'Pricing' | translate }}</a>
      <a routerLinkActive="active" [routerLink]="language === 'en' ? ['contact'] : [language, 'contact']" class="group-item link">{{ 'Contact us' | translate }}</a>
    </div>
  </div>
  <div class="about-resources group">
    <h3 class="group-name">{{ 'Resources' | translate }}</h3>
    <a routerLinkActive="active" [routerLink]="language === 'en' ? ['faq'] : [language, 'faq']" class="group-item link">{{ 'FAQ' | translate }}</a>
    <a routerLinkActive="active" [routerLink]="language === 'en' ? ['documentation'] : [language, 'documentation']" class="group-item link">{{ 'Support Documentation' | translate }}</a>
    <a routerLinkActive="active" [routerLink]="language === 'en' ? ['privacy-policy'] : [language, 'privacy-policy']" class="group-item link">{{ 'Privacy Policy' | translate }}</a>
    <a routerLinkActive="active" [routerLink]="language === 'en' ? ['terms-of-service'] : [language, 'terms-of-service']" class="group-item link">{{ 'Terms of Service' | translate }}</a>
  </div>
  <div class="to-app group">
    <h3 class="group-name">{{ 'App' | translate }}</h3>
    <button type="button" (click)="goToLogin()" class="group-item link">{{ 'Log In' | translate }}</button>
    <button type="button" (click)="goToSignup()" class="group-item link">{{ 'Start Free' | translate }}</button>
  </div>
  <!-- <div class="app">
    
  </div> -->
  <div class="made-mobile">
    <ng-container *ngTemplateOutlet="made"></ng-container>
  </div>
</footer>

<ng-template #made>
  <p class="group-item">{{ 'Made with' | translate }} 💙️ {{ 'in New York City' | translate }}</p>
  <p class="group-item">&copy; CaseActive {{ currentYear }}</p>
  <p class="group-item">{{ 'All rights reserved' | translate }}</p>
</ng-template>
